module.exports = "/deep/ .mat-dialog-container{\r\n    background: #cdefec;\r\n}"